import React from "react";
import "./redesign.css";

export function SectionSkeleton({ variant = "cards" }: { variant?: "cards" | "upcoming" | "awards" }) {
  return <div className={`profile-skeleton-list is-${variant}`} role="status" aria-label="Loading content" aria-busy="true">
    {[0, 1].map(index => <div className="profile-skeleton-card" key={index} aria-hidden="true">
      <div className="profile-skeleton profile-skeleton-media" />
      <div className="profile-skeleton-copy"><div className="profile-skeleton profile-skeleton-line" /><div className="profile-skeleton profile-skeleton-line is-short" /></div>
    </div>)}
  </div>;
}

export function ProfileSkeleton() {
  return <main className="profile-redesign profile-skeleton-page" aria-label="Loading profile" aria-busy="true" role="status">
    <div className="profile-hero" aria-hidden="true"><div className="profile-identity">
      <div className="profile-skeleton profile-portrait" />
      <div className="profile-biography"><div className="profile-skeleton profile-skeleton-name" /><div className="profile-skeleton profile-skeleton-line is-short" /><div className="profile-skeleton profile-skeleton-description" /></div>
    </div></div>
    <div className="profile-sections"><SectionSkeleton variant="upcoming" /><div className="profile-section-divider" /><SectionSkeleton /></div>
  </main>;
}
